<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row
      class="d-flex"
    >
      <base-tile-card
        class="card-full-width mx-3"
      >
        <template v-slot:heading>
          Recently Created Accounts
        </template>
        <v-data-table
          :headers="headers"
          :items="acctAccounts"
          :items-per-page="50"
          class="elevation-1"
          height="75vh"
        >
          <template v-slot:item.created_at="{ item }">
            {{ formatEpoch(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              text
              :href="'/#/staff/account/' + item.rowkey"
              target="_blank"
              color="info"
            >
              Record
            </v-btn>
          </template>
          <template v-slot:item._balanceDetails="{ item }">
            <template
              v-if="item._balanceDetails && item._balanceDetails.balance"
            >
              {{ item._balanceDetails.balance}}
            </template>
          </template>
        </v-data-table>
      </base-tile-card>
    </v-row>
  </v-container>
</template>

<script>
  import {
    mapActions,
    mapGetters,
  } from 'vuex'
  import {
    ACCT_GET_ACCOUNTS,
  } from '../../../store/actions.types'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'ReportingNewAccounts',
    components: {
    },
    mixins: [basicMixin],
    data () {
      return {
        page: 1,
        pageSize: 50,
        windowSize: {
          x: 0,
          y: 0,
        },
        itemHeight: 65,
        headers: [
          {
            text: 'Created',
            align: 'start',
            sortable: true,
            value: 'created_at',
          },
          { text: 'User/Email', value: 'user_email_address' },
          { text: 'Display Name', value: 'display_text' },
          { text: 'Balance', value: '_balanceDetails' },
          { text: 'Actions', value: 'actions' },
        ],
      }
    },
    computed: {
      ...mapGetters(['acctAccounts']),
      powUrl: {
        get () {
          return `${process.env.VUE_APP_API_POW_URL}`
        },
      },
    },
    async created () {
      this.getAccounts({
        page: this.page,
        pageSize: this.pageSize,
        withDetails: true,
        staffOverride: true,
      })
      this.onResize()
    },
    methods: {
      ...mapActions({
        getAccounts: ACCT_GET_ACCOUNTS,
      }),
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        if (this.windowSize.x > 600) {
          this.itemHeight = 65
        } else {
          this.itemHeight = 350
        }
      },
    },
  }
</script>
